"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { challengeScenarios } from "@/lib/data/site";
import { SectionHeader } from "@/components/ui/section-header";
import { useCursor } from "@/providers/cursor-provider";

export function ChallengeSolutions() {
  const { setLabel } = useCursor();

  return (
    <section className="relative overflow-hidden py-20 sm:py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_10%_20%,var(--hero-glow-2),transparent_50%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_90%_80%,var(--hero-glow-1),transparent_55%)]" />
      <div className="container-wide relative">
        <SectionHeader
          eyebrow="Your challenges"
          title={"YOUR CHALLENGES.\nOUR ENGINEERING RESPONSE."}
          description="Whether you need custom software development, generative AI in production, cloud modernization, or a dedicated engineering team — we align delivery to your stage and timeline."
        />

        <div className="mt-12 grid gap-4 sm:mt-14 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {challengeScenarios.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                href={item.href}
                className="card-lift group flex h-full flex-col rounded-[1.5rem] border border-border bg-card/80 p-6 backdrop-blur-xl sm:p-7"
                onMouseEnter={() => setLabel("OPEN")}
                onMouseLeave={() => setLabel(null)}
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="font-mono text-[11px] text-accent">0{index + 1}</span>
                  <ArrowUpRight className="h-4 w-4 text-muted transition group-hover:text-accent" />
                </div>
                <h3 className="mt-4 font-display text-xl tracking-tight text-foreground sm:text-2xl">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted">{item.problem}</p>
                <ul className="mt-5 space-y-2 border-t border-border pt-5">
                  {item.helps.map((help) => (
                    <li key={help} className="flex items-start gap-2 text-sm text-foreground/85">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan" />
                      {help}
                    </li>
                  ))}
                </ul>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
